/* eslint-disable react-hooks/exhaustive-deps */

import { Button } from 'antd';
import IconSuccressMail from '../../assets/Images/icons/icon-seccess-mail';
import IconLogo from '../../assets/Images/icons/icon-logo';
import { useTranslation } from 'react-i18next';

export default function SuccessForm(props) {
    const { t } = useTranslation();
    return (
        <>
            <div className="px-12 text-center">
                <div className="text-4xl mt-8">
                    <IconLogo />
                </div>
                <div className="text-4xl">
                    <IconSuccressMail />
                </div>
                <div className="mb-4 pt-4 text-base font-semibold">
                    {props.currentPageAction.text === 'RESETMAIL'
                        ? t('passwordPage.PleaseCheckYourEmail')
                        : t('passwordPage.SuccessfullyResetPassword2')}
                </div>
                <div className="text-[#65707A] text-xs">
                    {t('passwordPage.SentPasswordRecoverInstructions')}
                </div>
                <div className="mt-6">
                    <Button
                        size="large"
                        block
                        type="primary"
                        htmlType="submit"
                        onClick={() =>
                            props.setCurrentPageAction({
                                name: 'LOGIN',
                                mail: '',
                                text: '',
                            })
                        }
                    >
                        {t('passwordPage.BackToLogin')}
                    </Button>
                </div>
            </div>
        </>
    );
}
